import React, { Component } from 'react'
import ProposalSectionLinesPreview from './ProposalSectionLinesPreview'

class ProposalSectionPreview extends Component {
  renderGroup = section => {
    return (
      <li>
        <span style={{ textTransform: 'uppercase' }}>{section.name}</span>
        <ProposalSectionLinesPreview proposalItems={section.items} sectionId={section.id} />
      </li>
    )
  }

  render() {
    const { section } = this.props

    return this.renderGroup(section)
  }
}

export default ProposalSectionPreview



// WEBPACK FOOTER //
// ./src/components/templates/ProposalSectionPreview.js